import { createApi } from '@reduxjs/toolkit/query/react';

import { errorHandler } from './error-handler';
import { fetchBaseQuery } from './fetch-base-query';

interface UserInvitationsEntry {
  email: string;
  expirationDate: number;
  invitationID: number;
  organizationName: string;
  sendDate: number;
  senderName: string;
}

interface UserInvitationsResponse {
  usersInvitations: UserInvitationsEntry[];
}

interface UpdateInvitationStatusRequest {
  invitationID: number;
  accept: boolean;
}

export interface SendUserInvitationRequest {
  targetEmail: string;
  assignedRole: string;
}

export interface InvitationDataEntry {
  assignedRole: string;
  inviteEmail: string;
  status: string;
}

interface PendingInvitationListResponse {
  InvitationData: InvitationDataEntry[];
}

interface InvitationCodeResponse {
  code: string;
  email: string;
  hasDecided: boolean;
  inviteStatus: boolean;
  isExpired: boolean;
  organizationName: string;
  senderName: string;
}

export const userInviteApi = createApi({
  reducerPath: 'userInviteApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    receiveUserInvitation: builder.query<UserInvitationsResponse, void>({
      query: () => ({
        url: '/userInvitations',
        method: 'GET',
      }),
    }),

    sendUserInvitation: builder.mutation<void, SendUserInvitationRequest>({
      query: (data) => {
        const formData = new FormData();
        formData.append('targetEmail', data.targetEmail);
        formData.append('assignedRole', data.assignedRole);
        return {
          url: `/userInvitations`,
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          // data:
          // {
          //   "Result": "Succesfully Sent the Invitation!"
          // }
          // UIkit.modal.dialog(
          //   '<p class="uk-modal-body">The invitation was sent successfully. It could be in a spam folder. You will now be redirected to the organization dashboard.</p>'
          // );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
          // const { message } = errorHandler(err);
          // if (message === 'ERROR: Not a Valid Email') {
          //   // UIkit.modal.dialog(
          //   //   '<p class="uk-modal-body">The invitation was not sent. Please enter a valid email.</p>'
          //   // );
          // } else if (
          //   message === 'user is already a part of your organization'
          // ) {
          //   // UIkit.modal.dialog(
          //   //   '<p class="uk-modal-body">The invitation was not sent. The user is already a part of your organization.</p>'
          //   // );
          // } else if (
          //   message === 'There is a pending invitation sent to this user.'
          // ) {
          //   // UIkit.modal.dialog(
          //   //   '<p class="uk-modal-body">The invitation was not sent. The user already has a pending invitation from your organization. It could be in a spam folder.</p>'
          //   // );
          // } else {
          //   // UIkit.modal.dialog(
          //   //   '<p class="uk-modal-body">The invitation was not sent. Something went wrong, please try again later.</p>'
          //   // );
          // }
        }
      },
    }),

    updateInvitationStatus: builder.mutation<
      UserInvitationsResponse,
      UpdateInvitationStatusRequest
    >({
      query: (data) => {
        const formData = new FormData();
        formData.append('decision', data.accept.toString());
        return {
          url: `/userInvitation/${data.invitationID}`,
          method: 'PUT',
          body: formData,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            userInviteApi.util.updateQueryData(
              'receiveUserInvitation',
              undefined,
              (draft) => {
                draft.usersInvitations = data.usersInvitations;
              }
            )
          );
        } catch (err) {
          // Error can be found in network tab and RTK middleware
          const { message } = errorHandler(err);
          if (message === 'This invitation has already been used.') {
            // UIkit.modal.dialog(
            //   '<p class="uk-modal-body">This invitation has already been used.</p>'
            // );
          }
        }
      },
    }),

    getPendingInvitationsData: builder.query<
      PendingInvitationListResponse,
      void
    >({
      query: () => ({
        url: '/pendingInvitations',
        method: 'GET',
      }),
    }),

    // For handling the signup process when using the invitation link.
    getInvitationDataFromCode: builder.query<InvitationCodeResponse, string>({
      query: (code) => ({
        url: `/invitationCodeCheck/${code}`,
        method: 'GET',
      }),
    }),
  }),
});
